import dotProp from 'dotprop';

export default (element, prop) => {
  return eval('element.' + prop);
  return dotProp(element, prop);
};
